// Util bersama untuk fitur Template & Import Excel pada editor entri Activity.
// Format kolom diturunkan dari cfg.cols (sumber kebenaran tunggal per sub-activity),
// sehingga template & parsing selalu sinkron dengan form di layar.
import * as XLSX from "xlsx-js-style";

const pad2 = (n) => String(n).padStart(2, "0");

// Konversi nilai sel Excel (Date dari cellDates, atau string) → ISO utk input date/datetime.
export function excelToISO(v, withTime) {
  const d = v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return String(v); // biarkan apa adanya bila bukan tanggal valid
  const base = `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  return withTime ? `${base}T${pad2(d.getHours())}:${pad2(d.getMinutes())}` : base;
}

// Kolom yang bisa diimpor dari Excel (label, UoM, & kolom turunan read-only diabaikan).
export const importableCols = (cfg) =>
  cfg.cols.filter((c) => c.type !== "label" && c.type !== "uom" && c.type !== "computed");

// Unduh template .xlsx sesuai format form (header + 1 baris contoh).
export function downloadTemplate(cfg, itemLabel) {
  const cols = importableCols(cfg);
  const headers = cols.map((c) => c.label);
  const sample = cols.map((c) =>
    c.type === "date" ? "2026-06-01"
      : c.type === "month" ? "2026-06"
      : c.type === "datetime-local" ? "2026-06-01T08:00"
      : c.type === "number" ? 0
      : c.type === "check" ? "false"
      : "");
  const ws = XLSX.utils.aoa_to_sheet([headers, sample]);
  ws["!cols"] = headers.map((h) => ({ wch: Math.max(14, h.length + 2) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Template");
  const safe = String(itemLabel).replace(/[^\w-]+/g, "_").slice(0, 40);
  XLSX.writeFile(wb, `template-${safe}.xlsx`);
}

// Baca file Excel → daftar entri (cocokkan kolom via label header). Promise<entries>.
export function parseEntriesFromExcel(file, cfg, blankRow) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const wb = XLSX.read(ev.target.result, { type: "array", cellDates: true });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: false, raw: true });
        if (!rows.length) return reject(new Error("File kosong"));
        const cols = importableCols(cfg);
        const hdr = (rows[0] || []).map((h) => String(h).trim().toLowerCase());
        const mapped = cols.map((c) => ({ ...c, idx: hdr.indexOf(c.label.toLowerCase()) }));
        const entries = rows.slice(1)
          .filter((r) => r && r.some((v) => v !== "" && v != null))
          .map((r) => {
            const e = blankRow();
            mapped.forEach(({ key, type, idx }) => {
              if (idx < 0) return;
              let v = r[idx];
              if (v == null || v === "") return;
              if (type === "date") v = excelToISO(v, false);
              else if (type === "month") {
                const iso = /^\d{4}-\d{2}$/.test(String(v).trim()) ? `${String(v).trim()}-01` : excelToISO(v, false);
                v = iso.slice(0, 7) + "-01";
              }
              else if (type === "datetime-local") v = excelToISO(v, true);
              else if (type === "check") v = /^(true|1|ya|yes|y)$/i.test(String(v).trim());
              e[key] = v;
            });
            return e;
          });
        if (!entries.length) return reject(new Error("Tidak ada baris data pada Excel"));
        resolve(entries);
      } catch (err) {
        reject(err);
      }
    };
    reader.readAsArrayBuffer(file);
  });
}
